import React from 'react';
import {
  Router as HashRouter,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import history from './history';
import routers from './routers';

import Home from '../containers';
import ErrorPage from '../components/homePage/errorPage';
import LoginForm from './login';
import SignLab from '../components/login/signLab';
import SignUser from '../components/login/signUser'


export default () => (
  <HashRouter history={history}>
    <div className="h">
      <Switch>
        <Route exact path="/" render={() => { return (<Redirect to="/login" />) }}></Route>
        <Route path="/login" component={LoginForm} />
        <Route path="/signLab" component={SignLab} />
        <Route path="/signUser" component={SignUser} />
        {
          routers.map((route, index) => {
            return (
              <MainRoute
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component} />
            )
          })
        }

        <Route component={ErrorPage}></Route>
      </Switch>
    </div>
  </HashRouter>
);

// 包装/合成
const MainRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => {
      return (
        <Home>
          <Component {...props} />
        </Home>
      )
    }
    } />
  )
}


// class PrivateRoute extends React.Component {
//   componentWillMount() {
//     //getLoggedUser()
//   }
//   render() {
//     const { component: Component, user, ...rest } = this.props;
//     return (
//       <Route {...rest} render={props => {
//         return !user
//           ? <Redirect to="/index/homePage" />
//           : <Redirect to="/login" />
//       }} />
//     )
//   }
// }

// const stateToProps = ({ user }) => ({
//   user: user
// })

// const AuthorizedRoute =  connect(stateToProps)(PrivateRoute)